import { isType, flattenChildren } from './react-children-utils/react-children-utils';

export function pluralise(count, singular, plural) {
    const pluralWord = plural ?? `${singular}s`;

    return count === 1 ? singular : pluralWord;
}

export function getValidationMessage(element) {
    if (!element?.props) {
        return false;
    }
    return element.props['data-valmsg-for'];
}

export function getValidationSummary(element) {
    if (!element?.props) {
        return false;
    }
    return element.props['data-valmsg-summary'];
}

export function checkHTMLBool(value) {
    // bool value is only false when the attribute is omitted.
    // setting an attribute without a value in HTML can result in
    // the attribute being passed with an empty string value into React.

    // in this case the attribute should be true as by HTML standards,
    // however this is a falsy value in JS and will be false on checks
    // https://github.com/facebook/react/issues/13400

    return value === 'true' || value === true || value === '';
}

export function initFieldIsValids(controls) {
    // Try to get any prefilled values from the input fields to
    // initialise correct validation states for the form.
    const fieldIsValids = {};

    controls.forEach((control) => {
        const controlChildren = flattenChildren(control.props.children);
        const inputContainer = controlChildren.find((c) => isType(c, 'InputContainer'));

        const input = controlChildren.find((c) => isType(c, 'input'));

        // if the child of the Control element - ControlP, HalfWidthControlP
        // is just a standard input field set the default value.
        let defaultValue = input?.props?.defaultValue;

        const inputType = input?.props?.type;

        // if input type is number, default value should be converted from string to float
        if (inputType === 'number') {
            defaultValue = parseFloat(defaultValue);
        }

        if (checkHTMLBool(!inputContainer?.props?.required)) {
            // what we want with optional fields is to always return true.
            // it's either going to be empty or a prevalidated value from a previous
            // form submit.

            fieldIsValids[inputContainer.props.name] = true;
        } else {
            fieldIsValids[inputContainer.props.name] = defaultValue ?? false;
        }
    });

    return fieldIsValids;
}

export default {
    pluralise,
    initFieldIsValids,
    getValidationMessage,
    getValidationSummary,
};
